import styled from "styled-components";
export const HorizontalLine = styled.div`

        display: flex;
        align-items: center;
        margin-bottom: 42px;

        &::after,&::before{
            content: '';
            flex-grow: 1;
            height: 1px;
            background: #AFAFAF;
        }
        
        & .orText{
            margin: 0 10px;
            color: #757575;
        }
`